<template>
  <form
    :id="`new_${props.resourceName}`"
    class="login card"
    accept-charset="UTF-8"
    role="form"
    @submit.prevent="onSubmit"
  >
    <img :src="seraLogoUrl" class="login-logo" />
    <div class="simple-banner">Simple. Better. Sera!</div>
    <div class="px-4 mt-2">
      <div>
        <label class="login-label">Email Address</label>
        <input
          id="admin_email"
          v-model="email"
          type="email"
          class="form-control"
          autofocus="autofocus"
        />
        <label class="login-label">Password</label>
        <input
          id="admin_password"
          v-model="password"
          type="password"
          class="form-control mb-4"
        />
        <div v-if="props.isRememberable" class="checkbox">
          <label>
            <input
              id="admin_remember_me"
              v-model="rememberMe"
              class="login-checkbox"
              type="checkbox"
            />
            <span class="checkbox-text">Remember me</span>
          </label>
          <a v-if="props.isRecoverable" :href="props.resetPasswordUrl">
            Forgot your password?
          </a>
        </div>
        <div class="btn-container">
          <input
            type="submit"
            value="Sign In"
            class="btn btn-primary btn-sm mb-3"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script lang="ts" setup>
import API from "serviceshift-ui/api-client";
import { ref } from "vue";
import { attachNotificationHelper, authenticityToken } from "@/lib/helpers";
import useRouter from "@/lib/useRouter";

import seraLogoUrl from "@/images/sera-logo.svg?url";

const props = defineProps<{
  adminSignedIn: boolean;
  resourceName: string;
  url: string;
  isRememberable: boolean;
  isRecoverable: boolean;
  resetPasswordUrl: string;
}>();

const { router } = useRouter();

if (props.adminSignedIn) router.push("/");

const email = ref("");
const password = ref("");
const rememberMe = ref(false);

let isSubmitting = false;

const parser = new DOMParser();
window.notify = attachNotificationHelper();

const onSubmit = async () => {
  if (isSubmitting) return;
  isSubmitting = true;

  window.notify.close();

  if (!email.value || !password.value) {
    window.notify.error("Invalid Email or Password.");
    isSubmitting = false;
    return;
  }

  try {
    const res = await API.makeRequest(props.url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        skipRedirectOn401: true
      },
      data: {
        admin: {
          email: email.value,
          password: password.value,
          remember_me: rememberMe.value
        },
        commit: "Sign in",
        authenticity_token: authenticityToken()
      }
    });

    if (res.data.success && res.data.redirect_path) {
      location.replace(res.data.redirect_path);
    } else {
      window.notify.error("Login failed.");
      isSubmitting = false;
    }
  } catch (error) {
    if (error.response?.status === 401) {
      window.notify.error("Invalid Email or password.");
    } else if (error.response?.status !== 422) {
      window.notify.error("Unknown error has occurred.");
    }
    isSubmitting = false;
  }
};
</script>
